





import { Component, Prop, Vue } from "vue-property-decorator";
import { DataContainer } from '@/model/dataContainer/dataContainer';

import * as def from "@/definitions";

// Helper
import { FileHelper } from "@/helper/fileHelper";
import { NameHelper } from '@/helper/nameHelper';
import { MathHelper } from '@/helper/mathHelper';
import { ArrayHelper } from '@/helper/arrayHelper';
import { PathHelper } from '@/helper/pathHelper';
import { ImageHelper } from '@/helper/imageHelper';
import { VectorImageLayer } from '@/model/document2/page/surface/design/layer/vectorImageLayer';
import { RasterImageLayer } from '@/model/document2/page/surface/design/layer/rasterImageLayer';
import { CookieHelper } from "@/helper/cookieHelper"
import { DateHelper } from "@/helper/dateHelper"
import { DocumentHelper } from '@/helper/documentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { UuidHelper } from '@/helper/uuidHelper';
import { FontHelper } from '@/helper/fontHelper';
import { LogHelper } from "@/helper/logHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { StringHelper } from "@/helper/stringHelper";
import { NativeHelper } from '@/helper/nativeHelper';

@Component({
})
export default class BlankView extends Vue
{
    private mounted()
    {
        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        NativeHelper.sendNativeEvent("view_mounted", { view : "BlankView" });
    }

    private destroyed()
    {
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");
    }

    // コマンド処理
    private processExecCommand(paramParent : any)
    {
        var command : string = ""; 

        try
        {
            command = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "svg_to_png")
            {
                let svg : string = parameter.svg;
                let width : number = Number(parameter.width);
                let height : number = Number(parameter.height);
                let id  : string = parameter.id;

                // コンバート
                ImageHelper.svg2pngOnClient(svg, width, height, png => {
                    if(png == null || png == "") { return; }
                    // データコンテナにイメージを追加する
                    let dataContainter = this.$store.getters.dataContainer as DataContainer;
                    dataContainter.addConvertedImage(id, png);
                    // イメージ追加を通知
                    NativeHelper.sendNativeEvent("svg_to_png_completed", { id : id } );
                });
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
            NativeHelper.sendNativeEvent("error", { command : command } );
        }
    }
}
